









import { Vue, Component, Prop } from 'vue-property-decorator';
import HelpMessageIcon from '@common/assets/icons/help-message-icon.svg';

@Component({
  name: 'BaseHelpMessage',
  components: {
    HelpMessageIcon,
  },
})
export default class BaseHelpMessage extends Vue {
  @Prop() message: string;
  @Prop() error: boolean;
}
